const ADVERTISED_RETAILER = [
  {
    id: 5469,
    matchRegex: /\b(flower|flowers|gift|gifts|basket|baskets)\b/i,
  },
];

export default ADVERTISED_RETAILER;
